import { createBrowserRouter } from 'react-router-dom';
// import RequiredAuth from '../contexts/RequiredAuth';
import MainLayout from '../layout/MainLayout';
import Admin from '../Pages/Admin/Admin';
import Certificate from '../Pages/Certificate/Certificate';
import PostCertificate from '../Pages/Certificate/PostCertificate';
import College from '../Pages/College/College';
import PostCollege from '../Pages/College/PostCollege';
import DiffServices from '../Pages/DiffServices/DiffServices';
import PostDiffServices from '../Pages/DiffServices/PostDiffServices';

import Home from '../Pages/Home/Home';
import Login from '../Pages/Login/Login';
import NotFound from '../Pages/Shared/NotFound';
import PostSchool from '../Pages/School/PostSchool';
import School from '../Pages/School/School';

import SignUp from '../Pages/SignUp/SignUp';
import PostUniversity from '../Pages/University/PostUniversity';
import University from '../Pages/University/University';
import BackLink from '../Pages/Home/BackLink';
import ManageUniversity from '../Pages/Manage/ManageUniversity';
import ManageCertificate from '../Pages/Manage/ManageCertificate';
import ManageCollege from '../Pages/Manage/ManageCollege';
import ManageSchool from '../Pages/Manage/ManageSchool';
import ManageCareer from '../Pages/Manage/ManageCareer';
import RequiredAuth from '../contexts/RequiredAuth';


export const router = createBrowserRouter([

    {
    path: "/",element: <MainLayout/>, 
    children:[
      {path: "/", element: <Home />},
      {path: "/home", element: <Home />},
      {path: "/certificate", element: <RequiredAuth><Certificate /></RequiredAuth>},
      {path: "/school", element: <RequiredAuth><School /></RequiredAuth>},
      {path: "/college", element: <RequiredAuth><College /></RequiredAuth>},
      {path: "/university", element: <RequiredAuth><University /></RequiredAuth>},
      {path: "/career", element: <RequiredAuth><DiffServices /></RequiredAuth>},

      {path: "login",element: <Login />},
      {path: "signup",element: <SignUp />},
      {path: "services",element: <RequiredAuth><DiffServices /></RequiredAuth>},
      {path: "admin",element: <Admin />},
      {path: "backLink",element: <BackLink />},
      //post api
      {path: "postCertificate",element: <PostCertificate />},
      {path: "postSchool",element: <PostSchool />},
      {path: "postCollege",element: <PostCollege />},
      {path: "postUniversity",element: <PostUniversity />},
      {path: "postDiffServices",element: <PostDiffServices />},
      //delete api:
      {path: "manageUniversity",element: <ManageUniversity />},
      {path: "manageCareer",element: <ManageCareer />},
      {path: "manageSchool",element: <ManageSchool />},
      {path: "manageCollege",element: <ManageCollege />},
      {path: "manageCertificate",element: <ManageCertificate />},
      

      {path: "*",element: <NotFound />},

  
      
    ]},
    
  ]);